/* eslint-disable @next/next/no-img-element */
import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { BreakPoints } from "styles/styles"
import { CtaButton } from "@ui"
import parse from "react-html-parser"
import { useEffect, useState } from "react"

import OpenPositionsBgMobile from "./open-positions-bg-mobile.svg"
import OpenPositionsBg from "./open-positions-bg.svg"
import CreaturesSixtyNiningMobile from "./creatures-sixty-nining-mobile.png"
import CreaturesSixtyNining from "./creatures-sixty-nining.png"

const Jobs = () => {
  const {
    ResponsiveModel: { width },
    GlobalModel: { lang },
    VacanciesModel: { getTemplate },
  } = useStore()
  const isLessThanTablet = width > 0 && width < BreakPoints.tablet

  const [ctaRotation, setCtaRotation] = useState(-6)

  useEffect(() => {
    if (isLessThanTablet) {
      setCtaRotation(-2)
    } else {
      setCtaRotation(-6)
    }
  }, [isLessThanTablet])

  const title = parse(
    getTemplate("careers.jobs.title", false) || "Open Positions",
  )
  const ctaText = getTemplate("careers.jobs.cta") || "see open roles"
  const ctaLink =
    getTemplate("careers.jobs.ctaLink") || "https://pure.careers.hibob.com/jobs"
  const privacy = parse(
    getTemplate("careers.jobs.privacy", false) ||
      `We process applicant data as described in our <a href="/${lang}/gdpr" class="underline">privacy policy for job applications.</a>`,
  )

  return (
    <section className="relative w-full">
      <OpenPositionsBgMobile
        viewBox="0 0 375 558"
        className="block tablet:hidden absolute top-0 left-0 w-full h-full -z-1 pointer-events-none select-none"
      />
      <OpenPositionsBg
        viewBox="0 0 1440 395"
        className="hidden tablet:block absolute top-0 left-0 w-full h-full -z-1 pointer-events-none select-none"
      />
      <div className="max-w-screen-desktop-l mx-auto flex items-center flex-col tablet:flex-row tablet:justify-center px-[20px] pb-[30px]">
        <div className="mb-[20px] relative w-full tablet:w-fit laptop:flex laptop:items-end">
          <img
            src={CreaturesSixtyNiningMobile.src}
            alt="Creatures Sixty Nining"
            className="block tablet:hidden mx-auto w-full max-w-[400px] h-auto"
          />
          <img
            src={CreaturesSixtyNining.src}
            alt="Creatures Sixty Nining"
            className="hidden tablet:block mx-auto max-w-[400px] h-auto"
          />
          <h2 className="rotate-[-6.45deg] w-full h-fit laptop:w-[300px] absolute laptop:static bottom-0 laptop:mb-[20px] left-[50%] translate-x-[-50%] laptop:translate-x-[-20%] font-quirk-bold text-[32px] laptop:text-[64px] leading-[40px] laptop:leading-[70px] tracking-[1px] laptop:tracking-[4px] uppercase text-center laptop:text-start">
            {title}
          </h2>
        </div>

        <div className="tablet:pt-[50px] flex flex-col items-center tablet:items-start">
          <a href={ctaLink} target="_blank" rel="noopener noreferrer">
            <CtaButton text={ctaText} rotation={ctaRotation} />
          </a>
          <p className="rotate-0 tablet:rotate-[-3deg] w-full max-w-[300px] mt-[40px] mx-auto font-sans-bold text-black/30 leading-[18px] text-[11px] text-center tablet:text-left">
            {privacy}
          </p>
        </div>
      </div>
    </section>
  )
}

const JobsComponent = observer(Jobs)

export { JobsComponent }
